import React, { useState } from 'react';
import {
    Button
} from 'reactstrap';
import moment from 'moment';
import { toast } from 'react-toastify';
import { commonService } from '../../services';

function Export({ query, filters, moduleName, fileName, isDisabled, ext, label }) {
    const [isLoading, setIsLoading] = useState(false);

    const exportExcel = async () => {
        setIsLoading(true)
        const exportList = await commonService.export({
            query,
            filters,
            moduleName
        });
        setIsLoading(false);
        if (exportList?.data) {
            const url = window.URL.createObjectURL(new Blob([exportList?.data]), {
                type: 'text/plain'
            });
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${fileName}-${moment(new Date()).format('DD-MM-YYYY')}.${ext}`);
            toast.success('File exported successfully.');
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
        }
    };

    return (
        <div>
            <Button color="dark" className="ITC_Blue_borderButton outlineButton button_01"
                onClick={exportExcel} disabled={isDisabled || isLoading}><i className="bx bx-export pe-2" aria-hidden="true"></i>{label ? label : 'Export'}</Button>
        </div>
    );

}

export default Export;
